import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CertificationInterface } from 'src/app/model/certifications/certification-interface';
import { OrganisationInterface } from 'src/app/model/organisations/organisation-interface';
import { ProductInterface } from 'src/app/model/products/product-interface';
import { ListingsType } from 'src/app/model/stripe-models/listings/listings-type.enum';

@Component({
    selector: 'app-image-slider',
    templateUrl: './image-slider.component.html',
    styleUrls: ['./image-slider.component.scss'],
    animations: [
        trigger('carouselAnimation', [
            transition('void => *', [
                style({ opacity: 0 }),
                animate('500ms', style({ opacity: 1 }))
            ]),
            transition('* => void', [animate('500ms', style({ opacity: 0 }))])
        ])
    ],
    standalone: false
})
export class ImageSliderComponent implements OnInit, OnDestroy {
    @Input() item?: ProductInterface | CertificationInterface;
    @Input() category: string;
    @Input() organisation?: OrganisationInterface;
    @Input() autoPlay: boolean = false;
    @Input() autoPlayInterval: number = 4000;

    public test: CertificationInterface;
    public slides = [];
    currentSlide = 0;

    private autoPlayTimer: ReturnType<typeof setTimeout> | null = null;

    private readonly isBrowser: boolean;

    constructor(
        private cd: ChangeDetectorRef,
        @Inject(PLATFORM_ID) platformId: object
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    ngOnChanges() {
        this.slides = [];
        this.currentSlide = 0;
        if (this.item != null && this.category != 'organisation') {
            this.galleryItems();
        }

        if (
            this.item != null &&
            this.category === 'organisation' &&
            this.item.fileId != null
        ) {
            this.slides.push(this.item.fileId);
        }
        this.cd.detectChanges();
        this.restartAutoPlay();
    }

    ngOnInit(): void {
        switch (this.category) {
            case 'product':
                this.galleryItems();
                break;
            case 'certification':
                this.galleryItems();
                break;
            case 'organisation':
                break;
        }
        this.restartAutoPlay();
    }

    ngOnDestroy(): void {
        this.stopAutoPlay();
    }

    galleryItems() {
        this.slides = [];
        if (!this.item) {
            return;
        }

        if (this.item.listingPkgName == ListingsType.Free || !this.item.listingPkgName) {
            this.slides.push(this.item?.fileId);
            return;
        }
        if (this.item.fileId) {
            this.slides.push(this.item?.fileId);
        }
        if (Array.isArray(this.item?.galleryFileIds)) {
            this.item.galleryFileIds.forEach((item) => {
                this.slides.push(item);
            });
        }
    }

    onPreviousClick() {
        const previous = this.currentSlide - 1;
        this.currentSlide = previous < 0 ? this.slides.length - 1 : previous;
        this.restartAutoPlay();
    }

    onNextClick() {
        const next = this.currentSlide + 1;
        this.currentSlide = next === this.slides.length ? 0 : next;
        this.restartAutoPlay();
    }

    private restartAutoPlay(): void {
        this.stopAutoPlay();
        if (!this.isBrowser || !this.autoPlay || this.slides.length <= 1) return;
        this.scheduleNext();
    }

    private scheduleNext(): void {
        if (!this.isBrowser) {
            return;
        }

        this.autoPlayTimer = setTimeout(() => {
            if (!this.isBrowser) {
                return;
            }

            const next = this.currentSlide + 1;
            this.currentSlide = next === this.slides.length ? 0 : next;
            this.cd.detectChanges();
            this.scheduleNext();
        }, this.autoPlayInterval);
    }

    private stopAutoPlay(): void {
        if (this.autoPlayTimer !== null) {
            clearTimeout(this.autoPlayTimer);
            this.autoPlayTimer = null;
        }
    }
}
